if (!customElements.get('kvr-cinematic-hero')) {
  customElements.define('kvr-cinematic-hero', class extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.classList.add('is-visible');
        this.querySelectorAll('video').forEach((video) => video.play().catch(() => {}));
        this.observer.disconnect();
      }, { threshold: 0.15 });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}
